import React from 'react'
import { FormControl } from 'react-bootstrap'
import { set, replace } from 'lodash'
import moment from 'moment'
import humanizeDuration from 'humanize-duration'

export function getPeriodString(value) {
  return humanizeDuration(moment.duration(value).asMilliseconds(), { language: 'nl', units: ['y', 'mo', 'w', 'd'], conjunction: ' en ', round: true, largest: 2 })
}

export default class Period extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      days: this.parsePeriod(props.value, 'days'),
      weeks: this.parsePeriod(props.value, 'weeks'),
      months: this.parsePeriod(props.value, 'months'),
      years: this.parsePeriod(props.value, 'years')
    }
  }

  parsePeriod(value, type) {
    if (value && value !== '') {
      switch (type) {
        case 'days': return this.getRegexValue(value.match(/\d+D/))
        case 'weeks': return this.getRegexValue(value.match(/\d+W/))
        case 'months': return this.getRegexValue(value.match(/\d+M/))
        case 'years': return this.getRegexValue(value.match(/\d+Y/))
        default: return undefined
      }
    } else {
      return ''
    }
  }

  getRegexValue(val) {
    if (val && val[0]) {
      let match = val[0]
      return parseInt(match.slice(0, -1), 10)
    }
  }

  onChange(value, type) {
    let state = this.state
    let positiveValue = replace(value, /-/g, '')
    if (positiveValue) {
      positiveValue = parseInt(positiveValue, 10)
    }
    set(state, type, positiveValue)
    this.setState(state, () => this.props.onChange(this.getIso8601String()))
  }

  getIso8601String() {
    const { days, weeks, months, years } = this.state
    let period = `P${years && years !== 0 ? `${years}Y`: ''}${months && months !== 0 ? `${months}M`: ''}${weeks && weeks !== 0 ? `${weeks}W`: ''}${days && days !== 0 ? `${days}D` : ''}`
    if (period === 'P') {
      return undefined
    } else {
      return period
    }
  }

  render() {
    const { days, weeks, months, years } = this.state
    return <div className='period-input'>
      <table>
        <thead><tr><th>Dagen</th><th>Weken</th><th>Maanden</th><th>Jaren</th></tr></thead>
        <tbody>
          <tr>
            <td>
              <FormControl 
                type='number' 
                min={0} 
                className='input-text days' 
                autoFocus value={days} 
                onChange={(e) => this.onChange(e.target.value, 'days')} 
                disabled={this.props.disabled} 
              />
            </td>
            <td>
              <FormControl 
                type='number' 
                min={0} 
                className='input-text weeks' 
                autoFocus 
                value={weeks} 
                onChange={(e) => this.onChange(e.target.value, 'weeks')} 
                disabled={this.props.disabled} 
              />
            </td>
            <td>
              <FormControl 
                type='number' 
                min={0} 
                className='input-text months' 
                autoFocus 
                value={months} 
                onChange={(e) => this.onChange(e.target.value, 'months')} 
                disabled={this.props.disabled} 
              />
            </td>
            <td>
              <FormControl 
              type='number' 
              min={0} 
              className='input-text years' 
              autoFocus value={years} 
              onChange={(e) => this.onChange(e.target.value, 'years')} 
              disabled={this.props.disabled} 
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  }
}
